import request from '@/utils/request'

// 获取总数据
export function getPositionSum() {
    return request({
      url: '/bi/recruitment/position/getPositionSum',
      method: 'get'
    })
}

// 展示岗位缺口数量分析图（每日新增量）
export function getDaily(data) {
    return request({
      url: '/bi/recruitment/position/getDaily',
      method: 'post',
      data
    })
}

// 企业岗位缺口数量的排行榜（以发布的缺口数量排行）
export function getPositionRank(params) {
    return request({
      url: '/bi/recruitment/position/getPositionRank',
      method: 'post',
      data: params
    })
}

// 岗位缺口数量明细
export function getPositionDetail(data) {
  return request({
    url: '/bi/recruitment/position/getPositionDetail',
    method: 'post',
    data
  })
}

// 岗位缺口数量明细导出
export function exportPositionDetail(data) {
  return request({
    url: '/bi/recruitment/position/exportPositionDetail',
    method: 'post',
    data
  })
}

// 缺口岗位分布数据
export function getPositionTop(data) {
    return request({
      url: '/bi/recruitment/position/getPositionTop',
      method: 'post',
      data
    })
}

// 缺口岗位分布数据明细
export function getPositionTopDetail(data) {
    return request({
      url: '/bi/recruitment/position/getPositionTopDetail',
      method: 'post',
      data
    })
}

//  缺口岗位分布数据明细导出
export function exportPositionTopDetail(data) {
    return request({
      url: '/bi/recruitment/position/exportPositionTopDetail',
      method: 'post',
      data
    })
}